import { render } from "./Promotions-page.vue?vue&type=template&id=0b6de0e6&scoped=true"
import script from "./Promotions-page.vue?vue&type=script&lang=js"
export * from "./Promotions-page.vue?vue&type=script&lang=js"

import "./Promotions-page.vue?vue&type=style&index=0&id=0b6de0e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6de0e6"]])

export default __exports__